<div nz-row [nzGutter]="grid.gutter"  [nzAlign]="nzAlign">
  @for (control of allControls; track control) {
    <div
      [class.bt-row-hide]="control && !control.show(control)"
      nz-col
      [nzXs]="control?.grid?.xs || grid.xs"
      [nzSm]="control?.grid?.sm || grid.sm"
      [nzMd]="control?.grid?.md || grid.md"
      [nzLg]="control?.grid?.lg || grid.lg"
      [nzXl]="control?.grid?.xl || grid.xl"
      [nzXXl]="control?.grid?.xxl || grid.xxl">
      @if (!control && control !== null) {
        <nz-alert
          nzType="error"
          nzMessage="CONTROL is undefined">
        </nz-alert>
      }
      @if (control && control.controlType == 'message' && control.show(control)) {
        <bt-message-field
          [control]="control"
          [form]="control.fg || form"
          [options]="options"
          (change)="onChange($event)">
        </bt-message-field>
      }
      @if (control && control.controlType != 'message') {
        <bt-dynamic-form-control
          [control]="control"
          [form]="control.fg || form"
          [options]="options"
          (change)="onChange($event)" >
        </bt-dynamic-form-control>
      }
    </div>
  }


</div>
